module.exports = __webpack_public_path__ + "static/media/image34-m.1d95d018.webp";